// extracted by mini-css-extract-plugin
export default {"richList":"weSFl9Kei0w5g3kGB9ZK","title":"seADqX45EhNHTQTXv5Ti","content":"w1KvdqOW9KRDU2XaxAns","empty":"KgQ65CyzZtJNwfN1tHy5"};